import angular from 'angular';
import analyticsDashboards from '../Components/analyticsDashboards/analyticsDashboards.component';

export default angular
    .module('app.analytics.analyticsDashboards', [])
    .component("analyticsDashboards", analyticsDashboards)
    .name;